/**
 * Getting paid by the marketplace (docs/Decisions.md D72): a Stripe Connect
 * Express account for a person (salesperson balances, recommender rewards)
 * or for the organization (its share of lead fees). Stripe verifies identity
 * and issues tax forms; shares wait, held, until the account is ready.
 */
import { useEffect, useState } from 'react';
import * as marketApi from '../api/marketplace';
import { useToast } from './toast';
import { cn, ui } from '../lib/ui';

export default function PayoutAccountCard({ kind = 'user', title, children }) {
  const toast = useToast();
  const [account, setAccount] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    marketApi
      .getPayoutAccount(kind)
      .then(d => setAccount(d.account))
      .catch(() => setAccount({ exists: false, ready: false }));
  }, [kind]);

  async function onboard() {
    setBusy(true);
    try {
      const here = window.location.href;
      const data = await marketApi.startPayoutOnboarding(kind, here, here);
      window.location.assign(data.url);
    } catch (err) {
      toast.error(err.message || 'Stripe could not be reached');
      setBusy(false);
    }
  }

  return (
    <section className={cn(ui.cardFlat, 'mb-6')} aria-label={title}>
      <h3 className="mt-0 text-title-s">{title}</h3>
      {children}
      {account === null ? null : account.ready ? (
        <p className={cn(ui.alertSuccess, 'mb-0')}>
          Payouts are set up. Stripe pays out to your bank.
        </p>
      ) : (
        <>
          <p className="text-body-s">
            {account.exists
              ? 'Stripe still needs a few details before it can pay you.'
              : 'Set up payouts with Stripe, which verifies your identity and issues tax forms. Anything you earn is held until then.'}
          </p>
          <button
            type="button"
            className={cn(ui.btnSecondary, ui.btnSm)}
            disabled={busy}
            onClick={onboard}
          >
            {account.exists ? 'Finish setting up payouts' : 'Set up payouts'}
          </button>
        </>
      )}
    </section>
  );
}
